import RandBody from "./rand/Body.svelte";
import AboutBody from "./about/Body.svelte";
import CalendarBody from "./calendar/Body.svelte";
import HomeBody from "./home/Body.svelte";
import BoxesBody from "./boxes/Body.svelte";

export default {
  rand: {
    title: "Random Number",
    key: "rand",
    body: RandBody,
    params: "123",
  },
  home: {
    title: "Clime",
    key: "home",
    body: HomeBody,
    params: "123",
  },
  calendar: {
    title: "Planting Calendar",
    key: "calendar",
    body: CalendarBody,
    params: "123",
  },
  about: {
    title: "About Clime",
    key: "about",
    body: AboutBody,
  },
  boxes: {
    title: "DIY Garden Boxes",
    key: "boxes",
    body: BoxesBody,
  },
};
